import { pixels } from "../projects/CreateNewProject";
import { v4 } from "uuid";
import { MATERIAL_LENGTHS_FEET, LENGTH_LOOKUP_TABLE } from "../../constants/dimensions";

const lengthsInFeet = LENGTH_LOOKUP_TABLE;
const trimLengths = MATERIAL_LENGTHS_FEET;

const inchesToFeet = (inches) => {
  return inches / 12;
};

const sortSizes = (arr) => {
  let counters = {};
  for (let i = 0; i < arr.length; i++) {
    typeof counters[arr[i]] === "undefined"
      ? (counters[arr[i]] = 1)
      : counters[arr[i]]++;
  }
  return counters;
};

const findWindowInfo = (arr, key) => {
  let windowDimensions = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].windows > 1) {
      windowDimensions.push(arr[i].window1[key] / pixels);
      windowDimensions.push(arr[i].window2[key] / pixels);
    } else {
      windowDimensions.push(arr[i].window1[key] / pixels);
    }
  }

  return sortSizes(windowDimensions);
};

const findNumberOfWindows = (arr) => {
  let counter = arr.length;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].windows > 1) {
      counter++;
    }
  }
  return counter;
};

const findMaterialLengths = (obj, frequency) => {
  let materialItems = [];
  const keys = Object.keys(obj);

  for (let p = 0; p < keys.length; p++) {
    const key = keys[p];
    const keyLengthInFeet = inchesToFeet(key);

    for (let i = 0; i < trimLengths.length; i++) {
      if (keyLengthInFeet < trimLengths[i]) {
        materialItems.push({
          length: trimLengths[i],
          amount: obj[key] * frequency,
        });
        break;
      }
    }
  }
  return materialItems;
};

const condenseMaterialLengths = (inputArray) => {
  const arr = [...inputArray];
  let condensed = [arr[0]];
  for (let i = 1; i < arr.length; i++) {
    for (let k = 0; k < condensed.length; k++) {
      if (arr[i].length === condensed[k].length) {
        condensed[k].amount += arr[i].amount;
      } else {
        condensed.push(arr[i]);
      }
    }
  }
  return condensed;
};

export const findStandards = (walls) => {
  let counter = 0;
  for (let i = 0; i < walls.length; i++) {
    if (walls[i].windows < 1 && walls[i].doors < 1 && !walls[i].frenchDoor) {
      counter++;
    }
  }
  return counter;
};

export const find = (walls, input) => {
  if (input === "frenchDoor") {
    return walls.filter((wall) => wall[input]);
  }
  return walls.filter((wall) => wall[input] > 0);
};

export const sillLintel = (windows) => {
  let counter = 0;
  for (let i = 0; i < windows.length; i++) {
    if (windows[i].window1.windowW / pixels === 42) {
      counter += 45;
    } else {
      counter += windows[i].window1.windowW / pixels;
    }
    if (windows[i].windows === 2) {
      if (windows[i].window2.windowW / pixels === 42) {
        counter += 45;
      } else {
        counter += windows[i].window2.windowW / pixels;
      }
    }
  }

  return Math.ceil(counter / 12);
};

export const jacks = (windows) => {
  let counter = 0;

  for (let i = 0; i < windows.length; i++) {
    counter += windows[i].window1.sill / pixels;
    if (windows[i].windows === 2) {
      counter += windows[i].window2.sill / pixels;
    }
  }
  return Math.ceil(counter / 12);
};

export const trimmers = (windows) => {
  let counter = 0;
  for (let i = 0; i < windows.length; i++) {
    counter += windows[i].window1.windowH / pixels;
    if (windows[i].windows === 2) {
      counter += windows[i].window2.windowH / pixels;
    }
  }
  return Math.ceil(counter / 12);
};

export const cripple = (windows, doors) => {
  let counter = 0;

  for (let i = 0; i < windows.length; i++) {
    counter +=
      (windows[i].h -
        windows[i].window1.windowH -
        windows[i].window1.sill -
        windows[i].twoByW * 3) /
      pixels;
  }

  for (let i = 0; i < doors.length; i++) {
    counter += (doors[i].h - doors[i].doorH - windows[i].twoByW * 3) / pixels;
  }

  return Math.ceil(counter / 12);
};

export const doorSides = (doors) => {
  let counter = 0;
  for (let i = 0; i < doors.length; i++) {
    counter += doors[i].doorH;
  }
  return Math.ceil(counter / pixels / 12);
};

export const windowOrder = (windows) => {
  let sortedWindows = [];
  for (let i = 0; i < windows.length; i++) {
    let w = windows[i].window1.windowW;
    let h = windows[i].window1.windowH;
    let type = windows[i].window1.windowType;
    let tempered = windows[i].window1.tempered;

    let unique = true;
    for (let k = 0; k < sortedWindows.length; k++) {
      if (
        sortedWindows[k].w === w &&
        sortedWindows[k].h === h &&
        sortedWindows[k].type === type &&
        sortedWindows[k].tempered === tempered
      ) {
        sortedWindows[k].amount++;
        unique = false;
        break;
      } else {
        unique = true;
      }
    }
    if (unique) {
      sortedWindows.push({
        w: w,
        h: h,
        type: type,
        tempered: tempered,
        amount: 1,
      });
    }
  }
  return sortedWindows;
};

export const totalWindowH = (windows) => {
  let total = 0;
  for (let i = 0; i < windows.length; i++) {
    total += windows[i].window1.windowH / pixels;
  }
  return total;
};

export const totalDoorH = (doors) => {
  let total = 0;
  for (let i = 0; i < doors.length; i++) {
    total += doors[i].doorH / pixels;
  }
  return total;
};

//// NEW CALCULATIONS

export const categorySort = (arr) => {
  let categories = [];

  for (let i = 0; i < arr.length; i++) {
    if (!categories.includes(arr[i].category)) {
      categories.push(arr[i].category);
    }
  }

  return categories.sort();
};

export const calculateSiding = (walls, yurtTrait) => {
  const sidingWidth = 5.5;
  const topPlate = 1.5;
  const frenchDoorHeight = 81.5;
  let noSidingInInches = 0;

  walls.forEach((wall) => {
    if (wall.windows > 0) {
      noSidingInInches += wall.window1.windowH / pixels;
    }
    if (wall.windows > 1) {
      noSidingInInches += wall.window2.windowH / pixels;
    }
    if (wall.doors) {
      noSidingInInches += wall.doorH / pixels;
    }
    if (wall.frenchDoor === "center") {
      noSidingInInches += frenchDoorHeight;
    }
    // WORKING ON THE FRENCH DOORS
  });

  let total = Math.round(
    ((yurtTrait.h / pixels - topPlate) * yurtTrait.size - noSidingInInches) /
      sidingWidth
  );

  return [
    {
      type: "Cedar T&G",
      board: "1 x 6",
      purpose: "siding",
      length: '47 3/4"',
      amount: total,
      category: "bundle #5 (siding)",
      id: v4(),
    },
  ];
};

export const calculateCornerTrim = (walls, yurtTrait) => {
  const numberPerWall = 2;
  let h = yurtTrait.h / pixels / 12;
  if (yurtTrait.bottomPlate === "FIR") {
    h += 2;
  }
  const total = Math.ceil(walls.length * numberPerWall);

  return [
    {
      type: "Cedar TK",
      board: "1 x 4",
      purpose: "Corner Trim",
      length: `${lengthsInFeet[h]}'`,
      amount: total,
      category: "bundle #2 (trim)",
      id: v4(),
    },
  ];
};

export const calculateWindowTopAndBottom = (walls) => {
  let windows = find(walls, "windows");
  let numberOfWindows = findNumberOfWindows(windows);

  return [
    {
      type: " 2 BTR Cedar",
      board: "1 x 4",
      purpose: "Window Top & Bottom",
      length: "8'",
      amount: numberOfWindows,
      category: "bundle #2 (trim)",
      id: v4(),
    },
  ];
};

const findNormalWindows = (windows) => {
  let arr = [];
  for (let i = 0; i < windows.length; i++) {
    if (windows[i].windows > 0) {
      if (windows[i].window1.windowW / pixels !== 36) {
        arr.push(windows[i]);
      }
    }
    if (windows[i].windows > 1) {
      if (windows[i].window2.windowW / pixels !== 36) {
        arr.push(windows[i]);
      }
    }
  }
  return arr;
};

const findCasementWindows = (windows) => {
  let arr = [];
  for (let i = 0; i < windows.length; i++) {
    if (windows[i].windows > 0) {
      if (windows[i].window1.windowW / pixels === 36) {
        arr.push(windows[i]);
      }
    }
    if (windows[i].windows > 1) {
      if (windows[i].window2.windowW / pixels === 36) {
        arr.push(windows[i]);
      }
    }
  }
  return arr;
};

export const calculateWindowSides = (walls) => {
  const sidesPerWindow = 1;
  let windows = find(walls, "windows");
  let normalWindows = findNormalWindows(windows);

  let windowHeights = findWindowInfo(windows, "windowH");

  let materialLengths = findMaterialLengths(windowHeights, sidesPerWindow);
  let condensedMaterial = condenseMaterialLengths(materialLengths);

  let fullMaterialDescriptions = [];
  for (let i = 0; i < condensedMaterial.length; i++) {
    let e = condensedMaterial[i];
    fullMaterialDescriptions.push({
      type: " 2 BTR Cedar",
      board: "1 x 3",
      purpose: "Window Sides",
      length: `${e ? e.length : 0}'`,
      amount: e ? e.amount : 0,
      category: "bundle #2 (trim)",
      id: v4(),
    });
  }
  return fullMaterialDescriptions;
};

export const calculateCasementWindowSides = (walls) => {
  const sidesPerWindow = 1;
  let windows = find(walls, "windows");
  let casementWindows = findCasementWindows(windows);
  let windowHeights = findWindowInfo(casementWindows, "windowH");

  let materialLengths = findMaterialLengths(windowHeights, sidesPerWindow);
  let condensedMaterial = condenseMaterialLengths(materialLengths);

  let fullMaterialDescriptions = [];
  for (let i = 0; i < condensedMaterial.length; i++) {
    let e =
      typeof condensedMaterial[i] === "undefined" ? 0 : condensedMaterial[i];
    fullMaterialDescriptions.push({
      type: " 2 BTR Cedar",
      board: "1 x 6",
      purpose: "Casement Window Sides",
      length: `${e ? e.length : 0}'`,
      amount: e ? e.amount : 0,
      category: "bundle #2 (trim)",
      id: v4(),
    });
  }
  return fullMaterialDescriptions;
};

export const calculateWindowEdgeTrim = (walls) => {
  const sidesPerWindow = 2;
  let windows = find(walls, "windows");
  let windowHeights = findWindowInfo(windows, "windowH");
  let materialLengths = findMaterialLengths(windowHeights, sidesPerWindow);
  let condensedMaterial = condenseMaterialLengths(materialLengths);
  let fullMaterialDescriptions = [];
  for (let i = 0; i < condensedMaterial.length; i++) {
    let e = condensedMaterial[i];
    fullMaterialDescriptions.push({
      type: " 2 BTR Cedar",
      board: "1 x 4",
      purpose: "Window Edge Trim",
      length: `${e.length}'`,
      amount: e.amount,
      category: "bundle #2 (trim)",
      id: v4(),
    });
  }
  return fullMaterialDescriptions;
};

export const calculateDoorLintel = (walls) => {
  let doors = find(walls, "doors");
  const numberOfDoors = Math.round(doors.length / 2);

  return [
    {
      type: " 2 BTR Cedar",
      board: "1 x 4",
      purpose: "Door Lintel",
      length: "8'",
      amount: numberOfDoors,
      category: "bundle #2 (trim)",
      id: v4(),
    },
  ];
};

const findDoorInfo = (arr) => {
  let doorHeights = [];
  for (let i = 0; i < arr.length; i++) {
    doorHeights.push(arr[i].doorH / pixels);
  }

  return sortSizes(doorHeights);
};

export const calculateDoorEdgeSides = (walls) => {
  const edgesPerDoor = 2;
  let doors = find(walls, "doors");
  const doorHeights = findDoorInfo(doors);
  const materialLengths = findMaterialLengths(doorHeights, edgesPerDoor);
  const condensedMaterial = condenseMaterialLengths(materialLengths);

  let fullMaterialDescriptions = [];
  for (let i = 0; i < condensedMaterial.length; i++) {
    let e =
      typeof condensedMaterial[i] === "undefined" ? 0 : condensedMaterial[i];
    fullMaterialDescriptions.push({
      type: " 2 BTR Cedar",
      board: "1 x 6",
      purpose: "Door Edge Sides",
      length: `${e ? e.length : 0}'`,
      amount: e ? e.amount : 0,
      category: "bundle #2 (trim)",
      id: v4(),
    });
  }
  return fullMaterialDescriptions;
};

export const calculateBottomPlates = (walls, yurtTrait) => {
  let numberOfWalls = 0;
  let wallsPerBoard = 4;
  if (yurtTrait.bottomPlate === "CEDAR") {
    numberOfWalls = walls.length;
  }
  const total = Math.ceil(numberOfWalls / wallsPerBoard);

  return [
    {
      type: "Cedar",
      board: "2 x 6",
      purpose: "Bottom Plates (Slab)",
      length: "16'",
      amount: total,
      category: "bundle #1 (framing)",
      id: v4(),
    },
  ];
};

export const calculateCornerStuds = (walls, yurtTrait) => {
  const h = yurtTrait.h / pixels / 12;

  const lengths = {
    8: "8'",
    9: "10'",
    10: "10'",
    11: "12'",
    12: "12'",
    13: "14'",
    14: "14'",
    15: "16'",
    16: "16'",
    17: "20'",
    18: "20'",
    19: "20'",
    20: "20'",
  };

  const total = walls.length * 2;

  return [
    {
      type: "Fir",
      board: "2 x 8",
      purpose: "Corner Studs",
      length: lengths[h],
      amount: total,
      category: "bundle #1 (framing)",
      id: v4(),
    },
  ];
};
export const calculateBirdBlocks = (walls, yurtTrait) => {
  const total = Math.ceil((walls.length * 2) / 8);
  let boardSize = "2 x 10";
  if (yurtTrait.size === "16") {
    boardSize = "2 x 8";
  }

  return [
    {
      type: "Fir",
      board: boardSize,
      purpose: "Bird Blocks",
      length: "16'",
      amount: total,
      category: "bundle #1 (framing)",
      id: v4(),
    },
  ];
};

export const calculateRafterPlates = (walls, yurtTrait) => {
  const total = Math.ceil(walls.length / 4);
  let boardSize = "2 x 10";
  if (yurtTrait.size === "27" || yurtTrait.size === "32") {
    boardSize = "2 x 8";
  }
  return [
    {
      type: "Fir",
      board: boardSize,
      purpose: "Rafter Plates",
      length: "16'",
      amount: total,
      category: "bundle #1 (framing)",
      id: v4(),
    },
  ];
};

export const calculateRafters = (walls, yurtTrait) => {
  const rafterLengths = {
    32: "24'",
    27: "20'",
    24: "18'",
    20: "16'",
    16: "12",
  };

  let rafterBundle = {
    type: "Fir",
    board: "2 x 12",
    purpose: "Rafters",
    length: rafterLengths[parseInt(yurtTrait.size)],
    amount: yurtTrait.size * 2,
    category: "bundle #3 (rafters)",
    id: v4(),
  };

  if (yurtTrait.size === "32" || yurtTrait.size === "27") {
    rafterBundle.amount = rafterBundle.amount / 2;
    return [rafterBundle, rafterBundle];
  }

  return [rafterBundle];
};

export const calculateRafterPallet = (walls, yurtTrait) => {
  const size = parseInt(yurtTrait.size);
  const palletSizes = {
    32: { length: "16'", amount: 8 },
    27: { length: "16'", amount: 8 },
    24: { length: "14'", amount: 4 },
    20: { length: "10'", amount: 4 },
    16: { length: "8'", amount: 4 },
  };
  return [
    {
      type: "Pallet",
      board: "1 x 6",
      purpose: "Rafter Pallet",
      length: palletSizes[size].length,
      amount: palletSizes[size].amount,
      category: "bundle #3 (rafters)",
      id: v4(),
    },
  ];
};

export const calculateRafterTrim = (walls, yurtTrait) => {
  const total = yurtTrait.size * 2;
  const size = parseInt(yurtTrait.size);
  const lengths = {
    32: "20'",
    27: "18'",
    24: "16'",
    20: "12'",
    16: "10'",
  };
  return [
    {
      type: "Clear Hemlock",
      board: "1 x 3",
      purpose: "Rafter Trim",
      length: lengths[size],
      amount: total,
      category: "bundle #4 (rafter trim)",
      id: v4(),
    },
  ];
};

const findWindowHeaderSizes = (arr) => {
  let headerSizes = [];
  let sortedSizes = [];
  for (let i = 0; i < arr.length; i++) {
    // If the headers are included (the number three is the selection of the header amount)

    if (arr[i].window1.headerAmount / pixels < 3) {
      // add header size to array of sizes
      for (let k = 0; k < arr[i].window1.headerAmount / pixels + 1; k++) {
        headerSizes.push(arr[i].window1.header / pixels);
      }
    }
    if (arr[i].windows > 1 && arr[i].window2.headerAmount < 3) {
      for (let k = 0; k < arr[i].window2.headerAmount / pixels + 1; k++) {
        headerSizes.push(arr[i].window2.header / pixels);
      }
    }
  }
  for (let i = 0; i < headerSizes.length; i++) {
    if (!sortedSizes.some((e) => e.size === headerSizes[i])) {
      sortedSizes.push({
        size: headerSizes[i],
        amount: headerSizes.filter((e) => e === headerSizes[i]).length,
        purpose: "window headers",
      });
    }
  }
  return sortedSizes;
};

const findDoorHeaderSizes = (arr) => {
  let headerSizes = [];
  let sortedSizes = [];

  for (let i = 0; i < arr.length; i++) {
    if (arr[i].headerAmount / pixels < 3) {
      for (let k = 0; k < arr[i].headerAmount / pixels + 1; k++) {
        headerSizes.push(arr[i].header / pixels);
      }
    }
  }
  for (let i = 0; i < headerSizes.length; i++) {
    if (!sortedSizes.some((e) => e.size === headerSizes[i])) {
      sortedSizes.push({
        size: headerSizes[i],
        amount: headerSizes.filter((e) => e === headerSizes[i]).length,
        purpose: "door headers",
      });
    }
  }
  return sortedSizes;
};

const findFrenchDoorHeaderSizes = (arr) => {
  let headerSizes = [];
  let sortedSizes = [];
  let wallsPerFrenchDoor = 3;

  for (let i = 0; i < arr.length; i++) {
    if (arr[i].frenchHeaderAmount / pixels < 3) {
      const frenchDoorOpenings =
        (arr[i].frenchHeaderAmount / pixels + 1) / wallsPerFrenchDoor;
      for (let x = 0; x < frenchDoorOpenings; x++) {
        headerSizes.push(arr[i].frenchHeader / pixels);
      }
    }
  }
  for (let i = 0; i < headerSizes.length; i++) {
    if (!sortedSizes.some((e) => e.size === headerSizes[i])) {
      sortedSizes.push({
        size: headerSizes[i],
        amount: headerSizes.filter((e) => e === headerSizes[i]).length,
        length: "8'",
        purpose: "french door headers",
      });
    }
  }
  return sortedSizes;
};

const consolidateHeaders = (windows, doors) => {
  let sortedSizes = [];
  let allHeaders = [...windows, ...doors];

  for (let i = 0; i < allHeaders.length; i++) {
    if (!sortedSizes.some((e) => e.size === allHeaders[i].size)) {
      sortedSizes.push({
        size: allHeaders[i].size,
        amount: allHeaders[i].amount,
        purpose: allHeaders[i].purpose,
      });
    } else {
      const sortedIndex = sortedSizes.indexOf(
        sortedSizes.filter((e) => e.size === allHeaders[i].size)[0]
      );

      sortedSizes[sortedIndex].amount += allHeaders[i].amount;
      if (!sortedSizes[sortedIndex].purpose.includes(allHeaders[i].purpose)) {
        sortedSizes[sortedIndex].purpose =
          sortedSizes[sortedIndex].purpose + ", " + allHeaders[i].purpose;
      }
    }
  }
  return sortedSizes;
};

const checkBestBoardLengths = (arr) => {
  const headerWidth = 45;
  const lengthsInInches = [96, 120, 144, 192];
  const sixteenFootPiece = 192;
  const boardsNeeded = [];

  for (let i = 0; i < arr.length; i++) {
    let boardLeftovers = [];
    const amountOfSixteenFootBoardsNeeded = Math.floor(
      (arr[i].amount * headerWidth) / sixteenFootPiece
    );
    boardsNeeded.push({
      length: "16'",
      amount: amountOfSixteenFootBoardsNeeded,
      size: arr[i].size,
      purpose: arr[i].purpose,
    });
    for (let k = 0; k < lengthsInInches.length; k++) {
      const remainingInches = (arr[i].amount * headerWidth) % sixteenFootPiece;
      boardLeftovers.push({
        remaining: lengthsInInches[k] - remainingInches,
        length: lengthsInInches[k],
      });
    }
    const smallestBoard = boardLeftovers.reduce(function (prev, curr) {
      return prev.remaining < curr.remaining && prev.remaining > 0
        ? prev
        : curr;
    });
    boardsNeeded.push({
      length: `${smallestBoard.length / 12}'`,
      amount: 1,
      size: arr[i].size,
      purpose: arr[i].purpose,
    });
  }
  let consolidated = [];
  for (let i = 0; i < boardsNeeded.length; i++) {
    let element = boardsNeeded[i];
    if (
      consolidated.filter(
        (e) => e.length === element.length && e.size === element.size
      ).length
    ) {
      consolidated[
        consolidated.indexOf(
          consolidated.filter(
            (e) => e.length === element.length && e.size === element.size
          )[0]
        )
      ].amount += element.amount;
    } else {
      consolidated.push(element);
    }
  }
  return consolidated;
};

export const calculateHeaders = (walls, yurtTrait) => {
  const windows = findWindowHeaderSizes(find(walls, "windows"));
  const doors = findDoorHeaderSizes(find(walls, "doors"));
  const frenchDoors = findFrenchDoorHeaderSizes(find(walls, "frenchDoor"));
  const allHeaders = consolidateHeaders(windows, doors);

  const boardsNeeded = checkBestBoardLengths(allHeaders);

  const combinedBoards = [...boardsNeeded, ...frenchDoors];

  const headerSizes = {
    5.5: "2 x 6",
    7.25: "2 x 8",
    9.25: "2 x 10",
    11.25: "2 x 12",
  };

  const fullMaterialDescriptions = [];

  for (let i = 0; i < combinedBoards.length; i++) {
    let e = typeof combinedBoards[i] === "undefined" ? 0 : combinedBoards[i];
    fullMaterialDescriptions.push({
      type: "Fir",
      board: headerSizes[combinedBoards[i].size],
      purpose: combinedBoards[i].purpose,
      length: `${e ? e.length : 0}`,
      amount: e ? e.amount : 0,
      category: "bundle #1 (framing)",
      id: v4(),
    });
  }

  return fullMaterialDescriptions;
};

export const condenseMaterials = (materials) => {
  let newMaterials = [];
  let condensed = [];
  for (let material of materials) {
    newMaterials.push(material);
  }
  for (let material of newMaterials) {
    if (
      !condensed.some(
        (e) =>
          e.length === material.length &&
          e.board === material.board &&
          e.type === material.type
      )
    ) {
      condensed.push(material);
    } else {
      const materialIndex = newMaterials.indexOf(
        condensed.filter(
          (e) =>
            e.length === material.length &&
            e.board === material.board &&
            e.type === material.type
        )[0]
      );
      newMaterials[materialIndex].amount =
        parseInt(newMaterials[materialIndex].amount) +
        parseInt(material.amount);
      newMaterials[materialIndex].purpose += `, ${material.purpose}`;
    }
  }

  return condensed;
};
